import type { ProductListResultViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import PageSize from './PageSize/PageSize';
import Pagination from './Pagination/Pagination';
import useScrollToTopOfProductList from '../shared/hooks/useScrollToTopOfProductList';

export default function ProductListFooter({
    model: { pageSizes, pagingModel }
}: {
    model: ProductListResultViewModel;
}) {
    const scrollToTopOfProductList = useScrollToTopOfProductList();

    return (
        <Layout.Flex.Column justifyContent="center">
            <Pagination model={pagingModel} onPaginate={scrollToTopOfProductList} />
            <PageSize model={pageSizes} />
        </Layout.Flex.Column>
    );
}
